import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import BottomMenu from "./BottomMenu";
import {
  SalesforceExeSettingStep,
  DialogType,
  SalesforceExeExportObjectType,
} from "../../../../constants/ComponentTypes";
import { reverseSalesforceExeExportMap } from "../../../../utils/utils";
import ExeMappingTable from "./ExeMappingTable";

const styles = () => ({
  root: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    padding: "60px 0",
  },

  box: {
    maxWidth: "940px",
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginBottom: "90px",
  },

  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "26px",
  },

  desc: {
    fontSize: "14px",
    paddingBottom: "20px",
  },

  bottomMenu: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    zIndex: 2,
  },

  row: {
    marginBottom: "30px",
  },

  fieldTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  note: {
    color: "#5A5B62",
    fontSize: "12px",
    marginTop: "20px",
  },
});

class SalesforceExeExportMapping extends React.Component {
  state = {
    nextBtnPressed: true,
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isConfiguring &&
      !nextProps.isConfiguring &&
      this.state.nextBtnPressed
    ) {
      nextProps.goToStep(SalesforceExeSettingStep.SETTING_COMPLETE);
    }
  }

  /*** handlers ***/
  handlePrev = () => {
    const { type } = this.props;
    if (type === DialogType.EDIT) {
      if (this.props.step === SalesforceExeSettingStep.PREVIEW) {
        this.props.goToStep(SalesforceExeSettingStep.MAPPING);
      } else if (this.props.step === SalesforceExeSettingStep.MAPPING) {
        this.props.goBack();
      }
    } else {
      if (this.props.step === SalesforceExeSettingStep.PREVIEW) {
        this.props.goToStep(SalesforceExeSettingStep.MAPPING);
      } else if (this.props.step === SalesforceExeSettingStep.MAPPING) {
        this.props.goToStep(SalesforceExeSettingStep.SELECT_OBJECT);
      }
    }
  };

  handleNext = () => {
    const { mapping, sobject } = this.props;

    let map = reverseSalesforceExeExportMap(mapping);
    let mappingParams;

    if (sobject === SalesforceExeExportObjectType.LEAD.value) {
      mappingParams = {
        lead: map[SalesforceExeExportObjectType.LEAD.value],
      };
    } else {
      mappingParams = {
        account: map[SalesforceExeExportObjectType.ACCOUNT.value],
        contact: map[SalesforceExeExportObjectType.CONTACT.value],
      };
    }

    if (this.props.step === SalesforceExeSettingStep.MAPPING) {
      this.props.goToStep(SalesforceExeSettingStep.PREVIEW);
    } else if (this.props.step === SalesforceExeSettingStep.PREVIEW) {
      this.setState({
        nextBtnPressed: true,
      });
      this.props.postSalesforceExportMappingsExe(mappingParams);
    }
  };

  /*** render functions ***/

  renderBottomMenu = () => {
    //TODO: auto generate required fields
    let requiredFields = [];
    if (this.props.sobject === SalesforceExeExportObjectType.LEAD.value) {
      requiredFields = [
        {
          sobject_name: "Lead",
          field: "LastName",
          text: "リード・姓は必須です",
        },
      ];
    } else {
      requiredFields = [
        {
          sobject_name: "Account",
          field: "Name",
          text: "取引先・取引先名は必須です",
        },
        {
          sobject_name: "Contact",
          field: "LastName",
          text: "取引先責任者・姓は必須です",
        },
      ];
    }

    return (
      <BottomMenu
        requiredFields={requiredFields}
        step={this.props.step}
        open={true}
        mapping={this.props.mapping}
        isImporting={this.props.isImporting}
        next={this.handleNext}
        prev={this.handlePrev}
        isConfiguring={this.props.isConfiguring}
        showPrevButton={true}
      />
    );
  };

  render() {
    const { classes, step, mapping } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="subheading" className={classes.title}>
            {step === SalesforceExeSettingStep.MAPPING
              ? "同期する項目をマッピングしてください"
              : "以下のマッピングで同期します。よろしいですか？"}
          </Typography>
          <Typography variant="body2" className={classes.desc}>
            {step === SalesforceExeSettingStep.MAPPING
              ? "キーマンデータベースをSalesforceに同期する際の項目マッピングを設定します。下記Keyman Letterキーマンデータベース項目に該当するSalesforce項目を設定してください。この設定は「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。"
              : "問題ない場合は「設定を保存」ボタンをクリックして設定を完了させてください。キーマンデータベースのエクスポート設定は、「アカウント管理 > 連携 > Salesforce」よりいつでも変更できます。"}
          </Typography>

          {(() => {
            if (step === SalesforceExeSettingStep.PREVIEW) {
              return (
                <div className={classes.fields}>
                  <div className={classes.row}>
                    <Typography variant="title" className={classes.fieldTitle}>
                      Salesforceオブジェクト
                    </Typography>
                    <Typography variant="body2" className={classes.fieldDesc}>
                      {this.props.sobject ===
                        SalesforceExeExportObjectType.LEAD.value
                        ? SalesforceExeExportObjectType.LEAD.text
                        : "取引先・取引先責任者"}
                    </Typography>
                  </div>
                </div>
              );
            }
          })()}

          <div className={classes.row}>
            <Typography variant="title" className={classes.fieldTitle}>
              エクスポート設定・項目マッピング
            </Typography>
            <ExeMappingTable
              step={step}
              sobject={this.props.sobject}
              mapping={mapping}
              enableEdit={this.props.step === SalesforceExeSettingStep.MAPPING}
              disabled={this.props.isImporting || this.props.isLoadingPreview}
              updateMapping={this.props.updateMapping}
              isLoadingFields={this.props.isLoadingFields}
              accountFields={this.props.accountFields}
              contactFields={this.props.contactFields}
              leadFields={this.props.leadFields}
            />

            {step === SalesforceExeSettingStep.MAPPING && (
              <Typography className={classes.note}>
                ※1
                キーマンデータベースを連携する場合、セールスフォース上の取引先の有無に関わらず、キーマンの所属取引先が、新規取引先として追加されますので、ご注意ください。
              </Typography>
            )}
          </div>
        </div>
        <div className={classes.bottomMenu}>{this.renderBottomMenu()}</div>
      </div>
    );
  }
}

SalesforceExeExportMapping.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number,
  step: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  sobject: PropTypes.string,
  mapping: PropTypes.object,
  isImporting: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  isLoadingPreview: PropTypes.bool,
  isLoadingFields: PropTypes.bool,
  accountFields: PropTypes.object,
  contactFields: PropTypes.object,
  leadFields: PropTypes.object,
  goToStep: PropTypes.func.isRequired,
  goBack: PropTypes.func,
  updateMapping: PropTypes.func.isRequired,
  postSalesforceExportMappingsExe: PropTypes.func.isRequired,
};

SalesforceExeExportMapping.defaultProps = {
  type: DialogType.CREATE,
};

export default withStyles(styles)(SalesforceExeExportMapping);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceExeSetting/SalesforceExeExportMapping.jsx